module.exports = __webpack_public_path__ + "img/k_y@2x.25bb6948.png";